module.exports = __webpack_public_path__ + "4f79409842d51ee25e5c989a6758cb33.png";